import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_wrkrs_free_to_join_a_trade_union_of_their_choosing'

export const dataPointDefinition = {
  retracedId: 'are_wrkrs_free_to_join_a_trade_union_of_their_choosing',
  name: 'Are workers free to join a trade union of their choosing?',
  description:
    'A "trade union" refers to a workers’ organization constituted for the purpose of furthering and defending the interests of workers.\r\r\n\r\r\nUnion presence in the facility includes the existence of a company union and/or the affiliation of workers from the company to higher level unions (such as sectoral unions).\r\r\n\r\r\nILO Convention 87 on Freedom of Association and Protection of the Right to Organize Convention (1948) provides that workers have the right to join organizations of their own choosing without previous authorization, subject only to the rules of the organization concerned.\r\r\n\r\r\nIf there was no union presence in the facility during the assessment period, select the answer: Not applicable. No union presence in the facility during assessment period.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'union-na',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'union-na',
    },
    {
      name: 'Not applicable. No union presence in the facility during assessment period.',
      key: 'NOT_APPLICABLE_NO_UNION_PRESENCE_IN_THE_FAC_DURING_ASSESSMENT',
      slcpIndex: 3,
      slcpOptionName: 'union-na',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NOT_APPLICABLE_NO_UNION_PRESENCE_IN_THE_FAC_DURING_ASSESSMENT'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wi-foa-3',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 11740,
  sectionId: '2.2.8',
  impactArea: 'Freedom of Association and Collective Bargaining',
  impactAreaId: 'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
